<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <el-tabs v-model="form.activeTab">
        <el-tab-pane label="系统短信" name="system"></el-tab-pane>
        <el-tab-pane label="短信宝" name="smsbao"></el-tab-pane>
      </el-tabs>

      <!-- 系统短信配置 -->
      <div v-if="form.activeTab === 'system'">
        <div class="common-form">短信通知（云短信）</div>
        <el-form-item label="AccessKey">
          <el-input v-model="form.AccessKeyId" class="max-w460"></el-input>
          <div class="tips" v-if="!w7">
            <el-link :underline="false" href="http://pm.y01.cn/v2/pm/login/" target="_blank"
              type="primary">云短信免费申请</el-link>
          </div>
          <div v-else class="tips">
            请联系管理员
          </div>
        </el-form-item>
        <el-form-item label="AccessKeySecret">
          <el-input v-model="form.AccessKeySecret" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="短信签名">
          <el-input v-model="form.sign" class="max-w460"></el-input>
        </el-form-item>
        <div class="common-form">商家手机号设置（用于接收消息提醒）</div>
        <el-form-item label="接收手机号">
          <el-input v-model="form.accept_phone" class="max-w460"></el-input>
        </el-form-item>
        <div class="common-form">注册短信验证码模板（不填则表示不支持h5登录）</div>
        <el-form-item label="短信模板">
          <el-input v-model="form.template_code" class="max-w460" placeholder="SMS_174813569"></el-input>
        </el-form-item>
      </div>

      <!-- 短信宝配置 -->
      <div v-if="form.activeTab === 'smsbao'">
        <div class="common-form">短信宝配置</div>
        <el-form-item label="用户名">
          <el-input v-model="form.smsbao_username" class="max-w460" placeholder="请输入短信宝用户名"></el-input>
          <div class="tips">
            在短信宝平台注册的用户名
          </div>
        </el-form-item>
        <el-form-item label="密码/ApiKey">
          <el-input v-model="form.smsbao_password" class="max-w460" type="password" 
                   placeholder="请输入密码或ApiKey"></el-input>
          <div class="tips">
            平台登录密码MD5后的值(32位) 或 ApiKey(推荐)
          </div>
        </el-form-item>
        <el-form-item label="产品ID">
          <el-input v-model="form.smsbao_goodsid" class="max-w460" placeholder="请输入产品ID（可选）"></el-input>
          <div class="tips">
            专用通道产品ID，不填则使用通用短信产品
          </div>
        </el-form-item>
        <!-- <el-form-item label="短信签名">
          <el-input v-model="form.smsbao_sign" class="max-w460" placeholder="请输入短信签名"></el-input>
          <div class="tips">
            如：短信宝，将显示为【短信宝】
          </div>
        </el-form-item> -->
   
      </div>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        AccessKeyId: '',
        AccessKeySecret: '',
        sign: '',
        accept_phone: '',
        template_code: '',
        // 短信宝配置
        smsbao_username: '',
        smsbao_password: '',
        smsbao_goodsid: '',
        smsbao_sign: '',
        test_phone: '',
        test_content: '',
        activeTab: 'system',
      },

      w7: {},
      loading: false,
      testing: false,
      querying: false
    };
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.smsDetail({}, true)
        .then(data => {
          let vars = data.data.vars.values;
          // 系统短信配置
          self.form.AccessKeyId = vars.engine.aliyun.AccessKeyId;
          self.form.AccessKeySecret = vars.engine.aliyun.AccessKeySecret;
          self.form.sign = vars.engine.aliyun.sign;
          self.form.accept_phone = vars.engine.aliyun.accept_phone;
          self.form.template_code = vars.engine.aliyun.template_code;
          
          // 短信宝配置
          if (vars.engine.smsbao) {
            self.form.smsbao_username = vars.engine.smsbao.username || '';
            self.form.smsbao_password = vars.engine.smsbao.password || '';
            self.form.smsbao_goodsid = vars.engine.smsbao.goodsid || '';
            self.form.smsbao_sign = vars.engine.smsbao.sign || '';
          }
          
          self.w7 = data.data.w7;
        })
        .catch(error => {});
    },
    
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editSms(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，短信设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
    // 测试短信宝发送
    testSmsbao() {
      let self = this;
      if (!self.form.test_phone || !self.form.test_content) {
        self.$message.error('请填写测试手机号和测试内容');
        return;
      }
      
      self.testing = true;
      SettingApi.testSmsbao({
        phone: self.form.test_phone,
        content: self.form.test_content
      }, true)
        .then(data => {
          self.testing = false;
          if (data.code === 1) {
            self.$message({
              message: '测试短信发送成功',
              type: 'success'
            });
          } else {
            self.$message.error('发送失败：' + data.message);
          }
        })
        .catch(error => {
          self.testing = false;
          self.$message.error('发送失败');
        });
    },
    
    // 查询短信宝余额
    queryBalance() {
      let self = this;
      self.querying = true;
      SettingApi.querySmsbaoBalance({}, true)
        .then(data => {
          self.querying = false;
          if (data.code === 1) {
            self.$message({
              message: `当前余额：${data.data.balance} 条`,
              type: 'success'
            });
          } else {
            self.$message.error('查询失败：' + data.message);
          }
        })
        .catch(error => {
          self.querying = false;
          self.$message.error('查询失败');
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/sms/index.vue